import { SearchInput } from '@design-system/components/searchinput';
import { extrasVM } from '../Extras.page';

import { DropDownFilter } from '@design-system/components/dropDown/dropDownFilter';

import {
  filterAccessOptions,
  filterVisibilityOptions,
} from '../viewModel/extras.mappers';
import { PreviewToggleButton } from './PreviewToggleButton';
import { getAvailableFilterOptions } from '../viewModel/extras.mappers';
import { BasicMenu } from '@client/new/components/BasicMenu/BasicMenu';
import {
  filtersContainer,
  searchInputContainer,
  newButton,
  previewToggle,
} from './ExtrasFilters.css';

export const ExtrasFilters = () => {
  const vm = extrasVM.useValue();

  return (
    <div className={filtersContainer}>
      <div className={searchInputContainer}>
        <SearchInput
          placeholder="Search by name"
          value={vm.search}
          onChange={(e) => vm.dispatch('SetSearch', e.target.value)}
          onClear={() => vm.dispatch('SetSearch', '')}
        />
      </div>
      <DropDownFilter
        options={filterVisibilityOptions}
        onSelect={(value) =>
          vm.dispatch('SetFilter', { visibility: value || '' })
        }
        value={vm.filters.visibility}
        label="Visible to users"
      />
      <DropDownFilter
        options={filterAccessOptions}
        onSelect={(value) => vm.dispatch('SetFilter', { access: value || '' })}
        value={vm.filters.access}
        label="Access"
      />
      <DropDownFilter
        options={getAvailableFilterOptions(vm.contentMap)}
        onSelect={(value) => vm.dispatch('SetFilter', { type: value || '' })}
        value={vm.filters.type}
        label="Content type"
      />
      <div className={previewToggle}>
        <PreviewToggleButton
          isPreviewVisible={vm.showPreview}
          onClick={() => vm.dispatch('TogglePreview')}
          testId="toggle-extras-preview"
        />
      </div>
      <div className={newButton}>
        <BasicMenu
          buttonColor="primaryTonal"
          testId="extras-create-menu"
          title="New"
          items={vm.extrasMenu}
        />
      </div>
    </div>
  );
};
